/**
 * The accounts a migration can run against.
 *
 * Static, and deliberately a list rather than a constant: there is one today,
 * and the screen that shows it only earns its place once there are several.
 * Keeping the shape now means adding the second one is a data change.
 *
 * The backend still decides which AWS account and CX Designer workspace it
 * talks to, from its own environment - nothing here is sent with a migration.
 * When accounts become real this list comes from the server and carries the
 * credentials or role to use, and that is the point at which selecting one
 * starts to mean something.
 */

export interface Account {
  id: string;
  name: string;
  description: string;
}

export const ACCOUNTS: Account[] = [
  {
    id: "nlx-dev",
    name: "NLX-Dev",
    description: "Development workspace for Lex to CX Designer migrations.",
  },
];
